// @flow
import { MEDIA_TEXT_VERTICAL } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { CORE_GET_COMMON_I18N } from 'Utils/request/requestDictionary';

export const mediaTextVerticalResolver = {
  name: MEDIA_TEXT_VERTICAL,
  resolve(appContext: AppContext) {
    const query = `query {
      config {
        common {
          close
          seeMore
          loadLess
        }
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: CORE_GET_COMMON_I18N,
      strictErrors: false,
    });
  },
};
